import { Badge } from '@/components/ui/badge';

const items = [
  'Cybersecurity', 'Active Training Track', 'Threat Detection', 'AI & Machine Learning',
  'Career Placement', 'Cloud Security', 'Data Analytics', 'Penetration Testing',
  'SEO & Growth', 'Web Application Security', 'Network Defence', 'Digital Strategy',
];

export const MarqueeSection = () => {
  const doubled = [...items, ...items];

  return (
    <section
      data-testid="marquee-section"
      className="relative overflow-hidden py-3 border-y"
      style={{ background: 'var(--l1)', borderColor: 'var(--b1)' }}
    >
      <div
        className="flex items-center gap-8 whitespace-nowrap"
        style={{ animation: 'marqueeScroll 40s linear infinite' }}
        onMouseEnter={(e) => e.currentTarget.style.animationPlayState = 'paused'}
        onMouseLeave={(e) => e.currentTarget.style.animationPlayState = 'running'}
      >
        {doubled.map((item, i) => (
          <div key={`${item}-${i}`} className="flex items-center gap-8">
            {item === 'Active Training Track' ? (
              <Badge
                className="font-body text-xs px-3 py-1 rounded-full"
                style={{
                  background: 'rgba(139,92,246,0.08)',
                  border: '1px solid rgba(139,92,246,0.20)',
                  color: 'var(--a)',
                }}
              >
                <span
                  className="w-1.5 h-1.5 rounded-full mr-2 inline-block"
                  style={{ background: 'var(--a)', animation: 'pulseDot 2s ease-in-out infinite' }}
                />
                {item}
              </Badge>
            ) : (
              <span className="font-mono text-xs" style={{ color: 'var(--ts)' }}>{item}</span>
            )}
            <span style={{ color: 'var(--te)' }}>///</span>
          </div>
        ))}
      </div>
    </section>
  );
};
